<div class = "body">
    

    <div class = "afiliado" *ngIf = "rol == 'ROLE_ADMINISTRADOR'|| rol == 'ROLE_EJECUTIVO_CAIP' || rol == 'ROLE_ASISTENTE_SOCIAL' || rol == 'ROLE_ENCARGADO_NACIONAL' || rol == 'ROLE_EJECUTIVO' || rol == 'ROLE_ENCARGADO_CONTABILIDAD'|| rol == 'ROLE_CONTABILIDAD' || rol == 'ROLE_COORDINADOR' || rol == 'ROLE_ENCARGADO_REGIONAL' || rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE'">

        <div class = "container" style = "height:50px"> </div>
        
        <div class = "container"> 
                                 
            <div class = "row"  *ngIf = "rol == 'ROLE_ADMINISTRADOR'">
            
                <div class = "col-lg-10"> </div>
                        
                <div class = "col-lg-2"> <button class = "btn btn-success" (click) = "crearCarga()"> 
                    
                    <i class = "fa fa-plus"></i> Crear Carga </button> 
                    
                </div>
            
            </div>

        </div>

        <div class = "container" style = "height:50px"> </div>

        <div class = "container" id = "tabla" style = "background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class = "row">

                <div class = "col-lg-6"> <h1> Listado de Cargas </h1> </div>
                
                <div class = "col-lg-3"> </div>

                <div class = "col-lg-2">  <!-- <h3> Cantidad de Registros </h3>  --> </div>

                <div class = "col-lg-1">
                    <!--
                    <select class = "form-control" (change) = "cambiaCantidadRegistros()" [(ngModel)] = "config.itemsPerPage">
          
                        <option value = "10">10</option>
                        <option value = "20">20</option> 
                        <option value = "30">30</option>
                        <option value = "50">50</option>
                        <option value = "100">100</option>
                         
                    </select> 
                    -->
                </div>

            </div> <hr/> <br/> 

            <div class = "row">

                <div class = "col-lg-1"> <h3> RUT de Carga: </h3> </div>
                                
                <div class = "col-lg-3">

                    <input name = "rut" class = "form-control" [(ngModel)] = "rut"
                    placeholder = "Ingrese el RUT de la carga (11111111-1)" />  
                
                </div>

                <div class = "col-lg-1"> <h3> RUT de Titular: </h3> </div>
                                
                <div class = "col-lg-3">

                    <input name = "rutTitular" class = "form-control" [(ngModel)] = "rutTitular"
                    placeholder = "Ingrese el RUT del titular (11111111-1)" />  
                
                </div>
                
                <div class = "col-lg-1"> </div>
                
                <div class = "col-lg-2"> <button class = "btn btn-info" (click) = "buscar()"> 

                    <i class = "fa fa-search"></i> Buscar </button> 
            
                </div>

            </div> <br/> <br/> 

            <div class = "table-responsive">

                <table class = "table">
                
                    <thead style = "background-color: #0f69b4;color:white;">
                    
                        <tr>
                            <th scope = "col"> N° </th>

                            <th scope = "col"> Rut </th>

                            <th scope = "col"> Nombre y Apellido </th>

                            <th scope = "col"> Parentesco </th>
                            
                            <th scope = "col"> Fecha Ingreso </th>
                            
                            <th scope = "col"> Fecha Expiración </th>
                          
                            <th scope = "col">Rut titular </th>

                            <th scope = "col"> Editar </th>

                            <!-- <th scope = "col"> Cambiar Fecha Expiración </th> -->
                        </tr>

                    </thead>
                    
                    <tbody>

                        <tr [class] = "i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor = "let carga of cargasFinales | paginate: config; let i = index">

                            <td> {{carga.id}} </td>

                            <td> {{carga.rut}} - {{carga.dv}} </td>
                            
                            <td> {{carga.nombre}} {{carga.apellido}} </td>
                            
                            <td>  {{carga.parentesco}}   </td>

                            <td> {{carga.fechaCreacion}} </td>
                        
                            <td> {{carga.fechaExpiracion}}  </td> 

                            <td>  {{carga.rutTitular}} - {{carga.dvTitular}}</td>

                            <td> <button class = "btn btn-warning" (click) = "editarCarga(carga.id)" style = "width:100px"> 
                                    
                                <i class = "fa fa-pen"> </i> Editar 
                                
                            </button> </td>

                            <!--<td> <button class = "btn btn-danger" (click) = "modificarEstadoCarga(carga.id, carga.fechaExpiracion)"> 
                                    
                                <i class = "fa fa-pen"> </i> Modificar 
                                
                            </button> </td> -->
                        
                        </tr>
                    
                    </tbody>
                
                </table> <br/>

                <pagination-controls style = "text-align: center" previousLabel = "Anterior" nextLabel = "Siguiente" 
                (pageChange) = "pageChanged($event)" autoHide = "true"> </pagination-controls>
                            
            </div>
     
        </div>
        
        <div class = "container" style = "height:100px"> </div>
    
    </div>

</div>